import * as types from './mutations_type';

export default {
  [types.USERDATA](state, user_data) {
    state.userData = Object.assign({}, state.userData, user_data || {})
  },
  [types.USERWALLET](state, user_wallet) {
    state.userWallet = user_wallet
  },
  [types.ROUTERNAME](state, router_name) {
    state.routerName = router_name
  },

  ROOMS(state, cur) {
    window.localStorage.setItem('rooms', cur);
    state.rooms = cur;
  },

  ADULTS(state, cur){
    window.localStorage.setItem('adults', cur);
    state.adults = cur;
  },

  CHILDREN(state, cur){
    window.localStorage.setItem('children', cur);
    state.children = cur;
  },

  AGES(state, cur){
    window.localStorage.setItem('ages', cur.join(','));
    state.ages = cur.join(',');
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js